export const SPACE_TAB_LIST = [
    {
        value: "all",
        name: "all",
    },
    {
        value: "living room",
        name: "living room",
    },
    {
        value: "bed room",
        name: "bed room",
    },
    {
        value: "kids room",
        name: "kids room",
    },
    {
        value: "study room",
        name: "study room",
    },
];

export const SPACE_TAB_LIST_ATTRIBUTES = [
    {
        value: "all",
        name: "all",
    },
    {
        value: "Living room 客廳",
        name: "living room",
    },
    {
        value: "Bed room 臥房",
        name: "bed room",
    },
    {
        value: "Kids room 兒童房",
        name: "kids room",
    },
    {
        value: "Study room 書房",
        name: "study room",
    },
];

export enum ATTRIBUTE_TYPE {
    SINGLE_VALUE = "singleValue",
    MULTI_VALUE = "multiValue",
    RANGE = "range",
    CENTERED_RANGE = "centeredRange",
    TEXTFIELD = "textField",
    DATE = "date",
    LOCATION = "location",
}
